import React from "react";
import { Breadcrumb, Button, Col, Form, Input, Layout, Radio, Row, message } from "antd";
import { Link, Navigate } from "react-router-dom";

import { POST_API, POST_CATCH, getToken, titleWeb, verifyConfig } from "../../../services/api";

// CONTROLLER
import Page403 from '../../Controller/Page403';
import PageLoad from '../../Controller/PageLoad';

class AdminPlanoConfig extends React.Component {

    state = {
        _navigate: false,
        _loading: false,
        _screen: true,
        _params: window.location.href.split('/'),
        listItems: [],
        defaultValue: null
    }

    back = "/painel/planos";

    routes = [
        {title: <Link to={this.back}>Planos</Link>},
        {title: 'Configurações'}
    ]

    componentDidMount = () => {
        titleWeb('Planos')
        this.onLoadItems().then(() => this.onView())
    }

    onLoadItems = async () => {
        POST_API('/plan_meta/search.php', { token: getToken(), type: 'list' }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({listItems: res.data})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH())
    }

    onView = async () => {
        POST_API('/plan_meta_value/conf.php', { token: getToken(), filter: JSON.stringify({PLAN_ID: this.state._params[5]}) }).then(rs => rs.json()).then(res => {
            if (res.return) {
                this.setState({defaultValue: res.data})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_screen: false}))
    }

    onSend = (values) => {
        this.setState({_loading: true})
        POST_API('/plan_meta_value/save.php', { token: getToken(), master: JSON.stringify(values), ID: this.state._params[5] }).then(rs => rs.json()).then(res => {
            if (res.return) {
                message.success({ content: res.msg, key: 'screen' })
                this.setState({_navigate: true})
            } else {
                message.warning({ content: res.msg, key: 'screen' })
            }
        }).catch(() => POST_CATCH()).finally(() => this.setState({_loading: false}))
    }

    render = () => {

        if (this.state._navigate) return (<Navigate to={this.back} />)
        if (!verifyConfig(`${this.props.per}.${this.props.type}`)) return <Page403 />

        return (
            <Layout>
                <Layout.Content className={`admin-container`}>
                    <Row gutter={[8,8]} align={'middle'}>
                        <Col span={18}>
                            <Breadcrumb items={this.routes} />
                        </Col>
                        <Col span={6} style={{display: 'flex', justifyContent: 'flex-end'}}>
                            <Link to={this.back}><Button type="primary" size="small" shape="round" className="sys-btn-primary sys-btn-small">Voltar</Button></Link>
                        </Col>
                        { this.state._screen ? <PageLoad /> : (
                            <Col span={24}>
                                <Form layout="vertical" className={`admin-form`} onFinish={this.onSend} initialValues={this.state.defaultValue}>
                                    <Row gutter={[16,0]} align={'bottom'}>
                                        {this.state.listItems.map((v, i) => (
                                            <Col xs={24} md={ v.TYPE === 'B' ? 12 : 8 } key={i}>
                                                <Form.Item label={v.NAME} name={`CONFIG[${v.ID}]`} rules={[{required: true, message: 'Campo obrigatório*'}]}>
                                                    { v.TYPE === 'I' ? <Input type='number' min={-1} /> : null }
                                                    { v.TYPE === 'S' ? <Input type='text' /> : null }
                                                    { v.TYPE === 'B' ? <Radio.Group>
                                                        <Radio value={'S'}>Sim</Radio> 
                                                        <Radio value={'N'}>Não</Radio> 
                                                    </Radio.Group> : null }
                                                </Form.Item>
                                            </Col>
                                        ))}
                                        <Col xs={24} md={24}>
                                            <Button loading={this.state._loading} htmlType="submit" type="primary" shape="round" className="float-right">Salvar</Button>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        ) }
                    </Row>
                </Layout.Content>
            </Layout>
        )

    }

}

export default AdminPlanoConfig;